/** 根据 bundle 最低 App 版本派生正文留白；不引入新的 ViewIR 协议。 */
export function bodyHorizontalInset(blueprint) {
  const parts = String(blueprint?.app_min_version || '').trim().split(/[+-]/)[0].split('.');
  const minimum = [0, 9, 7];
  for (let i = 0; i < minimum.length; i++) {
    const part = Number(parts[i]) || 0;
    if (part !== minimum[i]) return part > minimum[i] ? 0 : 16;
  }
  return 0;
}

/** 滚动内容的四边内距采用逻辑像素，非法值归零，不能扩大滚动视口。 */
export function contentPadding(value = {}) {
  return Object.fromEntries(['top', 'right', 'bottom', 'left'].map((side) => {
    const n = value?.[side];
    return [`padding${side[0].toUpperCase()}${side.slice(1)}`, typeof n === 'number' && Number.isFinite(n) ? Math.max(0, n) : 0];
  }));
}
